import {createReducer} from '@reduxjs/toolkit';
import {SettingsState} from './types';
import {defaultLanguage} from 'i18n/i18n.config';
import {SettingsActions} from 'store/settings/settings.action';

const initialState: SettingsState = {
    language: defaultLanguage,
    serverLanguage:true,
    preloadBlinkId: false,
    isLoadingBlinkId: false,
};

export const settingsReducer = createReducer(initialState, (builder) => {
    builder.addCase(SettingsActions.setLanguageSetting, (state, action) => {
        const {language,overrideServer} = action.payload;
        return {
            ...state,
            language,
            serverLanguage: !overrideServer
        }
    });

    builder.addCase(SettingsActions.showAlert, (state, action) => {
        return {
            ...state,
            alert: action.payload
        }
    })

    builder.addDefaultCase((state, action) => {
        return state;
    });
});
